import { render, staticRenderFns } from "./OrderStatusHistoryTable.vue?vue&type=template&id=35fa9c58&scoped=true"
import script from "./OrderStatusHistoryTable.vue?vue&type=script&lang=js"
export * from "./OrderStatusHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./OrderStatusHistoryTable.vue?vue&type=style&index=0&id=35fa9c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fa9c58",
  null
  
)

export default component.exports